import './App.css';
import Header from './components/Header.js';
import Home from './components/Home.js';
import About from './components/About.js';
import ScreenshotsSection from './components/ScreenshotsSection.js';
import Process from './components/Process.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
import SectionWrapper from './components/compUse/SectionWrapper.js';
import MainSectionLayout from './components/compUse/MainSectionLayout.js';
import { useEffect, useRef, useState } from 'react';
import Visuals from './components/compUse/Visuals.js';
import WhatIsGrid from './components/WhatIsGrid.js';
import IntakeForm from './components/compUse/IntakeForm.js';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
const backgroundRef1 = useRef(null); // Voor Grid 1
const backgroundRef2 = useRef(null); // Voor Grid 2
const [isIntakeFormOpen, setIsIntakeFormOpen] = useState(false);

useEffect(() => {
const handleScroll = () => {
const scrollY = window.scrollY;
if (backgroundRef1.current) {
backgroundRef1.current.style.backgroundPositionY = `${-600 + scrollY * 0.5}px`;
}
if (backgroundRef2.current) {
backgroundRef2.current.style.backgroundPositionY = `${-600 + scrollY * 0.5}px`;
}
};

window.addEventListener('scroll', handleScroll);
return () => window.removeEventListener('scroll', handleScroll); // Cleanup
}, []);

const openIntakeForm = () => setIsIntakeFormOpen(true);
const closeIntakeForm = () => setIsIntakeFormOpen(false);

return (
<div className="main-container">
<Header openIntakeForm={openIntakeForm} />
<div className="mainContent">
<SectionWrapper>
<div id="home">
<Home openIntakeForm={openIntakeForm} />
</div>
</SectionWrapper>
<Visuals position="top" />
<MainSectionLayout>
<SectionWrapper>
<div id="watIsGridArea">
<WhatIsGrid />
</div>
</SectionWrapper>
                <Analytics />
                <SpeedInsights />
</MainSectionLayout>
<MainSectionLayout>
<SectionWrapper>
<ScreenshotsSection />
</SectionWrapper>
</MainSectionLayout>
<MainSectionLayout>
<SectionWrapper>
<About />
</SectionWrapper>
</MainSectionLayout>
<MainSectionLayout>
<SectionWrapper>
<div id="onsProcess">
<Process />
</div>
</SectionWrapper>
</MainSectionLayout>
<MainSectionLayout>
<SectionWrapper>
<Contact />
</SectionWrapper>
</MainSectionLayout>
<SectionWrapper>
<Footer />
</SectionWrapper>
</div>
<IntakeForm isOpen={isIntakeFormOpen} onClose={closeIntakeForm} />
</div>
);
}
export default App;